import type { SVGProps } from "react";
export interface BananaIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BananaIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BananaIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21.893 3.513c-.006.609-.016.863-.001 1.072.01.133.026.221.11.42l.256.594c.346.843.881 2.401.867 4.38-.017 2.515-.91 5.612-3.881 8.827l-.622.645c-2.044 2.029-4.67 3.03-7 3.438-2.158.378-4.208.273-5.48-.103l-.243-.079c-.51-.18-.94-.307-1.276-.376-.375-.078-.495-.052-.467-.059a1.126 1.126 0 1 1-.565-2.178l.187-.04c.443-.071.91-.008 1.298.072.48.099 1.018.263 1.571.458l.333.097c.88.21 2.454.307 4.254-.009 2.028-.355 4.179-1.206 5.804-2.818l.547-.568c2.611-2.822 3.277-5.389 3.29-7.322a9 9 0 0 0-.707-3.53l-.24-.56c-.354-.845-.296-1.353-.285-2.373v-.376h-.52V3.5q0 .051-.004.101c-.042.465-.142.879-.334 1.258a3.1 3.1 0 0 1-.681.878c-.491.46-.851.673-1.449 1.386-.558.665-.759 1.245-1.132 2.125-.332.783-.754 1.655-1.623 2.65l-.402.434c-.788.809-1.751 1.425-2.67 1.926-.885.482-1.89.938-2.591 1.293-1.168.592-1.834 1.018-2.454 1.462l-.621.457c-.28.21-.802.48-1.15.655a35 35 0 0 1-.511.252l-.161.078-.044.02-.013.006-.003.001h-.002v.002a1.125 1.125 0 0 1-.955-2.038l.003-.001.01-.005.04-.019.148-.071a27 27 0 0 0 1.002-.509q.119-.066.2-.115l.065-.04.019-.013.006-.005.674-.496c.683-.49 1.444-.976 2.73-1.628.859-.434 1.661-.786 2.531-1.26.837-.457 1.576-.946 2.136-1.521l.31-.334c.666-.76.98-1.408 1.256-2.06.322-.76.655-1.71 1.478-2.692l.264-.3c.606-.664 1.151-1.077 1.372-1.284a.9.9 0 0 0 .211-.25c.029-.056.07-.168.095-.41V2.5c0-.898.728-1.625 1.625-1.625h1.77c.898 0 1.625.727 1.625 1.625z"
      />
      <path
        fill={color}
        d="M2.432 16.401c.9-.311 1.72-.034 2.292.472.532.47.863 1.13 1.032 1.752.169.625.212 1.352.017 2.016-.19.648-.643 1.307-1.451 1.582l-.167.05c-.877.227-1.647-.072-2.184-.573-.502-.469-.81-1.107-.964-1.71-.156-.606-.189-1.297-.02-1.93.172-.641.595-1.342 1.42-1.65zm.768 2.133a.6.6 0 0 0-.038.107c-.051.19-.055.48.024.79.081.314.216.527.32.624.04.038.057.043.067.042.009-.014.026-.04.041-.09.051-.175.058-.468-.03-.795-.09-.329-.238-.553-.35-.651q-.021-.018-.034-.027m13.287-8.719a1.125 1.125 0 0 1 2.09.835c-1.627 4.067-4.755 6.18-8.24 7.735a1.126 1.126 0 0 1-.918-2.055c3.25-1.451 5.756-3.234 7.068-6.515"
      />
    </svg>
  );
}
